export default "__VITE_PUBLIC_ASSET__f1908da8__"